import { Button } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SkeletonLoaders } from '@hero/components';
import { PRODUCT_LIST_PAGINATION_LIMIT } from '@hero/constants';

import { EmptyTableContent } from '../../EmptyTableContent';
import { ProductCard } from '../Card/ProductCard';

import * as S from './style';

export const ProductList = ({
  pagination,
  fetchNextPage,
  data = [],
  isFetching,
  isFetchingNextPage,
  selectedProducts,
  openProductModal,
  isDraft
}) => {
  const { t } = useTranslation();

  const renderProductCard = product => {
    const { merchantProductId } = product || {};

    const selectedProduct = selectedProducts?.find(
      item => item.merchantProductId === merchantProductId
    );

    return (
      <S.ProductCardWrapper key={product.merchantProductId}>
        <ProductCard
          isDraft={isDraft}
          product={product || {}}
          isSelected={!!selectedProduct}
          onClick={() => openProductModal({ product, isSelected: !!selectedProduct })}
        />
      </S.ProductCardWrapper>
    );
  };

  return (
    <S.ProductList>
      {!isFetching && data?.length === 0 ? (
        <EmptyTableContent />
      ) : (
        <S.ListContainer>
          {isFetching && !isFetchingNextPage ? (
            <SkeletonLoaders.ProductLoader count={PRODUCT_LIST_PAGINATION_LIMIT} />
          ) : (
            data.map(renderProductCard)
          )}
          {isFetchingNextPage && (
            <SkeletonLoaders.ProductLoader count={PRODUCT_LIST_PAGINATION_LIMIT} />
          )}
        </S.ListContainer>
      )}

      {pagination?.hasNextPage && (
        <Button
          variant="outlined"
          disabled={isFetching || isFetchingNextPage}
          onClick={fetchNextPage}
          style={{ margin: '0 auto' }}
        >
          {isFetching || isFetchingNextPage ? t('loading') : t('loadMore')}
        </Button>
      )}
    </S.ProductList>
  );
};

ProductList.propTypes = {
  pagination: PropTypes.object,
  fetchNextPage: PropTypes.func,
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  isFetchingNextPage: PropTypes.bool,
  selectedProducts: PropTypes.array,
  openProductModal: PropTypes.func,
  isDraft: PropTypes.bool
};
